import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.css'
import cn from 'classnames'

export default function InternalHeader({children, className}) {
  return <header className={cn(styles.root, className)}>{children}</header>
}

InternalHeader.propTypes = {
  children: PropTypes.node
}
